import { render, staticRenderFns } from "./DefaultGatewayTransactionsPrintHtml.vue?vue&type=template&id=31ab4a44&scoped=true"
import script from "./DefaultGatewayTransactionsPrintHtml.vue?vue&type=script&lang=js"
export * from "./DefaultGatewayTransactionsPrintHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab4a44",
  null
  
)

export default component.exports